<style lang="scss">
</style>

<template>
    <div class="product-main">
        <div class="main-button-bar">
            <el-row class="search-row">
                <el-select
                    v-model="params.hasSeleted"
                    clearable
                    placeholder="入选状态"
                    class="search-item"
                >
                    <el-option
                        v-for="item in seletedStatus"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                    ></el-option>
                </el-select>

                <el-select v-model="params.status" clearable placeholder="是否上架" class="search-item">
                    <el-option
                        v-for="item in status"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                    ></el-option>
                </el-select>

                <el-select v-model="params.regionArr"  multiple collapse-tags clearable placeholder="主营范围(多选需同时满足)" class="search-item">
                    <el-option
                        v-for="item in $tools.productRegions"
                        :key="item"
                        :label="item"
                        :value="item"
                    ></el-option>
                </el-select>

                <el-select v-model="params.isBoutique" clearable placeholder="是否精品" class="search-item">
                    <el-option
                        v-for="item in status"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                    ></el-option>
                </el-select>

                <el-cascader
                    v-model="params.categoryArr"
                    clearable
                    collapse-tags
                    :show-all-levels="false"
                    placeholder="选择类型"
                    class="search-item"
                    :options="categorys"
                    :props="props"
                ></el-cascader>



                <sn-user-search-input
                    class="search-item"
                    @change="
              (a) => {
                params.seller = a;
              }
            "
                    title="选入员工名称"
                ></sn-user-search-input>

                <el-button
                    class="add-button"
                    type="success"
                    plain
                    icon="el-icon-plus"
                    size="small"
                    title="新增"
                    @click="add"
                ></el-button>
            </el-row>

            <el-row class="search-row">
                <el-select
                    v-model="params.shopsArr"
                    clearable
                    placeholder="销售范围(多选需同时满足)"
                    class="search-item"
                    multiple collapse-tags
                >
                    <el-option
                        v-for="item in shops"
                        :key="item.id"
                        :label="item.shortName"
                        :value="item.id"
                    ></el-option>
                </el-select>

                <el-date-picker
                    type="date"
                    placeholder="商品创建日期（开始）"
                    v-model="params.createTimeStart"
                    style="width:217px"
                    class="search-item"
                    value-format="yyyy-MM-dd"
                ></el-date-picker>
                <el-date-picker
                    type="date"
                    placeholder="商品创建日期（截止）"
                    v-model="params.createTimeEnd"
                    style="width:217px"
                    class="search-item"
                    value-format="yyyy-MM-dd"
                ></el-date-picker>
                
                <el-input v-model="params.name" placeholder="名称" class="search-item"></el-input>
                <el-input v-model="params.code" placeholder="编号" class="search-item"></el-input>
                <el-button type="primary" size="small" @click="search">搜索</el-button>
            </el-row>
        </div>
        <alibaba-product-add :show.sync="showAdd" :added="added" :prdId.sync="prdId" :isRelease="true"></alibaba-product-add>
        <alibaba-product-list
            ref="prdList"
            :height="this.$tools.mainHeight() - 105"
            :editFuc="edit"
            :searchParams="params"
            :isRoot="true"
            :isRelease="true"
            action="alibaba/product/myrelease"
        ></alibaba-product-list>
    </div>
</template>

<script>
import AlibabaProductAdd from "./Alibaba-product-add.vue";
import AlibabaProductList from "./Alibaba-product-list.vue";
import SnUserSearchInput from "../components/SnUserSearchInput.vue";

export default {
    components: { AlibabaProductList, AlibabaProductAdd, SnUserSearchInput },
    data() {
        return {
            params: {},
            categorys: [],
            props: {
                value: "id",
                label: "name",
                expandTrigger: "hover",
                emitPath: false,
                multiple: true,
            },
            products: [],
            showAdd: false,
            prdId: null,
            status: [
                { id: "Y", name: "是" },
                { id: "N", name: "否" },
            ],

            seletedStatus: [
                { id: "Y", name: "全部已选" },
                { id: "T", name: "部分已选" },
                { id: "N", name: "未选" },
            ],
            shops: null,
        };
    },
    methods: {
        getCategory() {
            let _this = this;

            _this.$http.post(
                ["alibaba/product/category/tree"],
                [
                    function (data) {
                        _this.categorys = data;
                    },
                ],
                ".product-main"
            );
        },
        add() {
            this.showAdd = true;
        },
        added() {
            this.$refs["prdList"].relaod();
        },
        edit(id) {
            this.prdId = id;
            this.showAdd = true;
        },
        search() {
            this.$refs["prdList"].relaod();
        },
        getShops() {
            let _this = this;

            _this.$http.post(
                ["alibaba/shop/valid"],
                [
                    function (data) {
                        _this.shops = data;
                    },
                ],
                ".alibaba-buyer-table"
            );
        },
    },
    mounted() {
        this.getCategory();
        this.getShops();
    },
};
</script>